var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupportWarrantyLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "coin",
    xmlns: "http://www.w3.org/2000/svg",
    width: 93,
    height: 93,
    viewBox: "0 0 93 93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_268",
    "data-name": "Group 268"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M184.159,132.279h-6.906a5.2,5.2,0,0,1,0-10.408h12.189a2.374,2.374,0,0,0,0-4.749H183.09v-4.848a2.374,2.374,0,0,0-4.749,0v4.848h-1.088a9.953,9.953,0,1,0,0,19.906h6.906a5.2,5.2,0,1,1,0,10.408H171.752a2.374,2.374,0,1,0,0,4.749h6.569v4.947a2.374,2.374,0,1,0,4.749,0v-4.947h1.207a9.953,9.953,0,0,0-.119-19.906Z",
    transform: "translate(-134.196 -88.154)",
    fill: "#1a1a1a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M79.386,13.614A46.508,46.508,0,0,0,13.614,79.386,46.508,46.508,0,0,0,79.386,13.614ZM46.5,88.251A41.751,41.751,0,1,1,88.251,46.5,41.81,41.81,0,0,1,46.5,88.251Z",
    fill: "#1a1a1a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportWarrantyLogo);
export default __webpack_public_path__ + "static/media/support-warranty-logo.31135054a215d251be213ecdcdbd18cb.svg";
export { ForwardRef as ReactComponent };